var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hvh-flex"},[_c('FixedPlaceholder',{attrs:{"component":_vm.TableauLeftMenu}}),_c('div',{staticClass:"grow-1 overflow-hidden"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }